// export const BASE_URL = "http://192.168.25.124:8000/api"
// export const BASE_URL = "https://tabaq.ae/admin/Api"
// export const BASE_URL = "http://localhost:8000/account"
export const BASE_URL = "https://api.tabaq.in/account"

// export const BASE_URL = "http://15.185.218.57:8000/api"